import { HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService } from 'src/app/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { areEqual } from 'src/app/shared/messages';

@Component({
  selector: 'app-clinician-form',
  templateUrl: './clinician.component.html',
  styleUrls: ['./clinician.component.less']
})
export class ClinicianComponent implements OnInit {

  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private _router: Router,
    private _dataService: CommonDataService,
    private location: Location) { }

  signupform = new FormGroup({});
  signupmodel: any = {};
  signupoptions: FormlyFormOptions = {};
  signupfields: FormlyFieldConfig[] = [];

  ngOnInit(): void {
    this.createSignUpForm();
    this._dataService.getUserDetails().subscribe(result => {
      const data = result.data;
      this.signupmodel = { ...data.Clinician };
    });
  }

  get isEditAccountPage() {
    return this._router.url.indexOf('edit-information') !== -1;
  }

  createSignUpForm() {
    this.signupfields = [
      {
        key: 'Salutation',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            { label: 'MR', value: 'MR' },
            { label: 'MRS', value: 'MRS' },
            { label: 'MS.', value: 'MS.' },
            { label: 'Dr', value: 'Dr' },
            { label: 'Other', value: 'Other' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSalutation'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'FirstName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblFirstName'),
        }
      },
      {
        key: 'LastName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblLastName'),
        }
      },
      {
        key: 'Degree',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          valuePrimitve: true,
          optionLabel: 'label',
          optionValue: 'value',
          optionsList: [{
            label: 'DO',
            value: 'DO'
          }, {
            label: 'FRCOG',
            value: 'FRCOG'
          }, {
            label: 'FRCS',
            value: 'FRCS'
          }, {
            label: 'MBBS',
            value: 'MBBS'
          }, {
            label: 'MD',
            value: 'MD'
          }, {
            label: 'MD MS',
            value: 'MD MS'
          }, {
            label: 'MD, PhD',
            value: 'MD, PhD'
          }, {
            label: 'MRCOG',
            value: 'MRCOG'
          }, {
            label: 'MS',
            value: 'MS'
          }, {
            label: 'PhD',
            value: 'PhD'
          }, {
            label: 'Other',
            value: 'Other'
          }]
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDegree'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'Email',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmail'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'Password',
        type: 'password',
        hide: this.isEditAccountPage,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: !this.isEditAccountPage
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPassword'),
        }
      },
      {
        key: 'ConfirmPassword',
        type: 'password',
        hide: this.isEditAccountPage,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: !this.isEditAccountPage,
          showPswdStrength: false
        },
        validators: {
          fieldMatch: {
            expression: (control: any) => {
              const value = control.value;
              if (control.parent && control.parent.controls && control.parent.controls.Password && control.parent.controls.Password.value) {
                return value === control.parent.controls.Password.value
                  || (!value || !control.parent.controls.Password.value);
              }
              return null;
            },
            message: areEqual,
          },
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblConfirmPassword'),
        }
      },
      {
        key: 'MobileNo',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMobileNo'),
          'templateOptions.disabled': (model, formState) => this.isEditAccountPage
        }
      },
      {
        key: 'AreaOfSpecialization',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            {
              "label": "Gastrointestinal Oncology",
              "value": "Gastrointestinal Oncology"
            },
            {
              "label": "Genitourinary Oncology",
              "value": "Genitourinary Oncology"
            },
            {
              "label": "Gynecologic oncology",
              "value": "Gynecologic oncology"
            },
            {
              "label": "Head and Neck Oncology",
              "value": "Head and Neck Oncology"
            },
            {
              "label": "Hematology",
              "value": "Hematology"
            },
            {
              "label": "Hematology Oncology",
              "value": "Hematology Oncology"
            },
            {
              "label": "Medical oncology",
              "value": "Medical oncology"
            },
            {
              "label": "Medicine",
              "value": "Medicine"
            },
            {
              "label": "Molecular Biology ",
              "value": "Molecular Biology "
            },
            {
              "label": "Neuro-oncology",
              "value": "Neuro-oncology"
            },
            {
              "label": "Other",
              "value": "Other"
            },
            {
              "label": "Pathologist",
              "value": "Pathologist"
            },
            {
              "label": "Pathology",
              "value": "Pathology"
            },
            {
              "label": "Pediatric oncology",
              "value": "Pediatric oncology"
            },
            {
              "label": "Radiation oncology",
              "value": "Radiation oncology"
            },
            {
              "label": "Sarcoma and Musculoskeletal Oncology",
              "value": "Sarcoma and Musculoskeletal Oncology"
            },
            {
              "label": "Surgical oncology",
              "value": "Surgical oncology"
            },
            {
              "label": "Thoracic Oncology",
              "value": "Thoracic Oncology"
            },
            {
              "label": "Uro-oncology",
              "value": "Uro-oncology"
            }
          ],
          valuePrimitve: true,
          filter: true,
          filterBy: 'value'
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAreaOfSpecialization'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'DiseaseSpecialization',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          optionsList: [
            {
              "label": "Acute Lymphoblastic Leukemia",
              "value": "Acute Lymphoblastic Leukemia"
            },
            {
              "label": "Acute Myeloid Leukemia",
              "value": "Acute Myeloid Leukemia"
            },
            {
              "label": "Bladder Cancer",
              "value": "Bladder Cancer"
            },
            {
              "label": "Brain Tumour",
              "value": "Brain Tumour"
            },
            {
              "label": "Breast Cancer",
              "value": "Breast Cancer"
            },
            {
              "label": "Chronic Lymphocytic Leukemia",
              "value": "Chronic Lymphocytic Leukemia"
            },
            {
              "label": "Chronic Myeloid Leukemia",
              "value": "Chronic Myeloid Leukemia"
            },
            {
              "label": "Colon and Rectal Cancer",
              "value": "Colon and Rectal Cancer"
            },
            {
              "label": "Endometrial Cancer",
              "value": "Endometrial Cancer"
            },
            {
              "label": "Esophageal and Gastric Cancer",
              "value": "Esophageal and Gastric Cancer"
            },
            {
              "label": "Head and Neck Cancer",
              "value": "Head and Neck Cancer"
            },
            {
              "label": "Hodgkin’s Lymphoma",
              "value": "Hodgkin’s Lymphoma"
            },
            {
              "label": "Kidney Cancer",
              "value": "Kidney Cancer"
            },
            {
              "label": "Leukemia",
              "value": "Leukemia"
            },
            {
              "label": "Liver Cancer",
              "value": "Liver Cancer"
            },
            {
              "label": "Lung Cancer",
              "value": "Lung Cancer"
            },
            {
              "label": "Melanoma and Skin Cancer",
              "value": "Melanoma and Skin Cancer"
            },
            {
              "label": "Multiple Myeloma",
              "value": "Multiple Myeloma"
            },
            {
              "label": "Non-Hodgkin Lymphoma",
              "value": "Non-Hodgkin Lymphoma"
            },
            {
              "label": "Other",
              "value": "Other"
            },
            {
              "label": "Pancreatic Cancer",
              "value": "Pancreatic Cancer"
            },
            {
              "label": "Prostate Cancer",
              "value": "Prostate Cancer"
            },
            {
              "label": "Thyroid Cancer",
              "value": "Thyroid Cancer"
            }
          ],
          valuePrimitve: true,
          filter: true,
          filterBy: 'value'
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDiseaseSpecialization'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'Hospital',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblHospital'),
        }
      },
      {
        key: 'Address',
        type: 'textarea',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAddress'),
        }
      },
      {
        key: 'AlternativeNumber',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAltMobileNo'),
        }
      },
      {
        key: 'Sex',
        type: 'dropdown',
        defaultValue: null,
        wrappers: ['fieldWrapper'],
        hide: true,
        templateOptions: {

          optionsList: [
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSex'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'MaritialStatus',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        hide: true,
        templateOptions: {
          optionsList: [
            { label: 'Single', value: 'Single' },
            { label: 'Married', value: 'Married' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMaritalStatus'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      },
      {
        key: 'PreviousTraining',
        type: 'textarea',
        wrappers: ['fieldWrapper'],
        templateOptions: {

        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPreviousTraining'),
        }
      },
      /* {
        key: 'file',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          type: 'file',
          change: (event, field) => this.fileUpload(event, field)
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPhotoUpload'),
        }
      }, */
      {
        key: 'DOB',
        type: 'date-picker',
        wrappers: ['fieldWrapper'],
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDOB'),
        }
      },
      {
        key: 'YearInService',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          valuePrimitve: true,
          optionsList: [{
            label: 1, value: 1
          }, {
            label: 2, value: 2
          }, {
            label: 3, value: 3
          }, {
            label: 4, value: 4
          }, {
            label: 5, value: 1
          }, {
            label: 6, value: 6
          }, {
            label: 7, value: 7
          }, {
            label: 8, value: 8
          }, {
            label: 9, value: 9
          }, {
            label: 10, value: 10
          }, {
            label: 11, value: 11
          }, {
            label: 12, value: 12
          }, {
            label: 13, value: 13
          }, {
            label: 14, value: 14
          }, {
            label: 15, value: 15
          }, {
            label: 16, value: 16
          }, {
            label: 17, value: 17
          }, {
            label: 18, value: 18
          }, {
            label: 19, value: 19
          }, {
            label: 20, value: 20
          },]
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblYearInService'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect')
        }
      }
    ];
  }

  registerClicked() {
    const headers = new HttpHeaders({
      'removeContentType': 'true'
    });
    const options: any = {};
    options['headers'] = headers;
    const value = { ...this.signupmodel };
    this._formValidationService.markFormGroupTouched(this.signupform);
    if (this.signupform.valid) {
      /* const formData: FormData = new FormData();
      for (var key in value) {
        formData.append(key, value[key]);
      } */
      this._ajaxService.post('/clinician/register', value).subscribe((response) => {
        const result = response.data;
        if (response.success) {
          this._confirmationService.confirm({
            message: (this.isEditAccountPage) ? this._translateService.instant('LblClinicianUpdated') : this._translateService.instant('LblClinicianRegistered'),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              //Actual logic to perform a confirmation
              if (!this.isEditAccountPage) {
                this.signupform.reset();
              } else {
                this.signupmodel = {
                  ...result
                }
                this.location.back();
              }
            }
          });
        }
      }, error => {
        this._confirmationService.confirm({
          message: error.error.error,
          rejectVisible: false,
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this._translateService.instant('LblOk'),
          accept: () => {
            //Actual logic to perform a confirmation
          }
        });
      });
    }

  }

  fileUpload(event: any, field: any) {
    const file: File = <File>field.target.files[0];
    event.model['file'] = file;
  }

  cancelClicked() {
    this.location.back();
  }

}
